<template>
  <popup :opened="dataToShow" @close="close">
    <!-- BEGIN Content modal add referent -->
    <div>
      <div class="my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32 text-center">
        <h3 class="mb-10">Supprimer le {{ filetype }} « {{ filename }} »</h3>

        <p class="text-indigo-600 text-lg">
          Êtes-vous sûr de vouloir supprimer le {{ filetype }} «
          {{ filename }} » ?
        </p>
        <p v-if="folder.type == 'folder'" class="text-indigo-600 text-lg">
          Son contenu sera également supprimé.
        </p>

        <div class="mt-5 text-red-500 text-sm text-center">
          {{ ((errors || [])['forbidden'] || [])[0] }}
        </div>

        <div class="flex justify-center space-x-5 mt-10">
          <action-button
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-100"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Annuler"
            :uppercase="true"
            @clickAction="close(false)"
          />
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            :bg-color="saving ? 'bg-gray-600' : 'bg-pink-600'"
            :bg-color-square="saving ? 'bg-gray-600' : 'bg-pink-600'"
            libelle="Supprimer"
            :uppercase="true"
            :type-shadow="saving ? 'shadow-gray' : 'shadow-pink'"
            @clickAction="deleteFolder()"
          />
        </div>
      </div>
    </div>
    <!-- END Content modal add referent -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import ActionButton from './../../../components/ActionButton';
import InputText from './../../../components/Inputs/InputText';
import Icon from './../../../components/Icon';

import Constants from './../../../constants';

export default {
  name: 'DeleteFolderPopup',

  props: {
    dataToShow: Boolean,
    saving: {
      type: Boolean,
      required: false,
      default: false,
    },
    parentFolder: {
      type: String,
      required: false,
      default: null,
    },
    folder: Object,
    errors: {
      type: Object,
      required: false,
      default: {},
    },
  },

  data() {
    return {
      //
    };
  },

  components: {
    Popup,
    ActionButton,
    InputText,
    Icon,
  },

  computed: {
    filetype: {
      get: function () {
        return this.folder.type == 'folder' ? 'dossier' : 'fichier';
      },
    },

    filename: {
      get: function () {
        return this.folder.name
          ? this.folder.type == 'folder'
            ? this.folder.name
            : this.folder.name.substring(0, this.folder.name.lastIndexOf('.'))
          : '';
      },
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },

    deleteFolder() {
      this.$emit('deleteFolder');
    },
  },
};
</script>
